var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tender-list-general-estimate-drop-zone h3"},[_c('span',[_vm._v(_vm._s(_vm.$t('Drop here to apply this price to the general estimate')))])])}
var staticRenderFns = []

export { render, staticRenderFns }